// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"e0fe1439","272":"8b8631c7","453":"392b3535","635":"f887119d","924":"0a34dc65"}[chunkId] + ".chunk.css";
};